/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDuoSecurity = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M3 3h9a9 9 0 1 1 0 18H3zm2 2v6h13.93A7.001 7.001 0 0 0 12 5zm13.93 8H5v6h7a7.001 7.001 0 0 0 6.93-6z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDuoSecurity as DuoSecurity };
